<template>
    <div class="answer" :class="state">
        <label @click="emitIfChecked($event)">
            <div class="container">
            <input type="radio" name="answer" :disabled="disabled" :checked="checked" @change="emitSelected" :value="answer.id">
            <!--<span class="radio"></span>-->
            {{ answer.answer }}
            </div>
        </label>
    </div>
</template>

<script>
    export default {
        props: {
            answer: {
                required: true,
                type: Object,
            },
            state: {
                required: false,
                type: String,
            },
            checked: {
                required: false,
                type: Boolean
            },
            disabled: {
                required: false,
                type: Boolean
            }
        },

        methods: {
            emitSelected() {
                this.$emit('selected', this.answer);
            },

            emitIfChecked($event) {
                if (this.checked && !this.disabled) {
                    $event.preventDefault();
                    this.$emit('selected', this.answer);
                }
            }
        }

    }
</script>